import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'label']

  connect() {
    this.updateLabel()
  }

  updateLabel() {
    this.labelTargets.forEach((label) => {
      const inputId = label.getAttribute('for')
      const input = this.element.querySelector(
        `input[type="radio"][id="${inputId}"]`,
      )
      if (input && input.checked) {
        label.classList.add('selected')
      } else {
        label.classList.remove('selected')
      }
    })
  }

  toggle() {
    this.updateLabel()
  }
}
